// extracted by mini-css-extract-plugin
export default {"depositsTable":"List_depositsTable__PPAqF","externalRef":"List_externalRef__qsHtj"};